import { put, call, takeEvery } from "redux-saga/effects";
import { claimDetail } from "../../Services/ClaimCashless";

export function* claimPendingDetailSaga(action) {
  const { payload } = action;
  try {
    const res = yield call(claimDetail, payload);
    yield put({
      type: "REQ_CLAIM_PENDING_DETAIL_SUCCEEDED",
      data: res.data.data,
    });
  } catch (e) {
    yield put({ type: "REQ_CLAIM_PENDING_DETAIL_FAILED", errData: e });
  }
}

export function* claimPendingDetailWatcher() {
  yield takeEvery("REQ_CLAIM_PENDING_DETAIL", claimPendingDetailSaga);
}
